import { render, staticRenderFns } from "./sidebarRecords.vue?vue&type=template&id=55b9826a"
import script from "./sidebarRecords.vue?vue&type=script&lang=js"
export * from "./sidebarRecords.vue?vue&type=script&lang=js"
import style0 from "./sidebarRecords.vue?vue&type=style&index=0&id=55b9826a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports